module.exports = "data:image/gif;base64,R0lGODlhEAAPAJEAAAAAAP///yWj7f///yH5BAEAAAMALAAAAAAQAA8AAAIjnCena5LM3INH2usQ3lnPJVUf+I1KR50mhabNCrVpyG1enRUAOw=="